export default __webpack_public_path__ + "static/media/emadbabur.82e280cc.jpg";